export default __webpack_public_path__ + "src/images/packages/marataba-conservation-camps/a92b11d7cccf6f7ffb80423f32c48238-4.jpg";